import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { formatDate } from '../../lib/utils/time';
import ExpiryBadge from './ExpiryBadge.svelte';
import Card from '../shared/Card.svelte';
import { deleteStorageEntry } from '../../lib/services/storage';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { formatVolume } from '../../lib/utils/units.ts';

var root_1 = $.from_html(`<div class="milk-row svelte-386dtghtcv4y5"><div class="milk-info svelte-386dtghtcv4y5"><span class="milk-label svelte-386dtghtcv4y5"> </span> <span class="milk-location svelte-386dtghtcv4y5"> </span></div> <div class="milk-meta svelte-386dtghtcv4y5"><!> <button class="delete-btn svelte-386dtghtcv4y5" aria-label="Delete"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" class="svelte-386dtghtcv4y5"><path d="M18 6L6 18M6 6l12 12"></path></svg></button></div></div>`);

function MilkCard($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	const locationLabels = {
		fridge: 'Fridge',
		freezer: 'Freezer',
		'deep-freezer': 'Deep Freezer'
	};

	async function handleDelete() {
		await deleteStorageEntry($$props.entry.id);
		$$props.ondelete?.();
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Card(node, {
		padding: 'sm',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var div_1 = $.child(div);
			var span = $.child(div_1);
			var text = $.child(span);

			$.reset(span);

			var span_1 = $.sibling(span, 2);
			var text_1 = $.child(span_1, true);

			$.reset(span_1);
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var node_1 = $.child(div_2);

			ExpiryBadge(node_1, {
				get expiresAt() {
					return $$props.entry.expiresAt;
				}
			});

			var button = $.sibling(node_1, 2);

			$.reset(div_2);
			$.reset(div);

			$.template_effect(
				($0, $1) => {
					$.set_text(text, `${$0 ?? ''} — ${$1 ?? ''}`);
					$.set_text(text_1, locationLabels[$$props.entry.location]);
				},
				[
					() => formatDate($$props.entry.storedAt),
					() => formatVolume($$props.entry.remainingVolumeMl, $.get(isImperial))
				]
			);

			$.delegated('click', button, handleDelete);
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	MilkCard = $.hmr(MilkCard);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-386dtghtcv4y5');
		MilkCard[$.HMR].update(module.default);
	});
}

export default MilkCard;

$.delegate(['click']);
import "bun-svelte:MilkCard.svelte-1k7y0lcl16mi5-style.css";